export default function fixDealTagsDuplicateModals() {
    const dealTagModalCtls = document.querySelectorAll(
        '.value-message__container [data-toggle="modal"]'
    );
    if (dealTagModalCtls.length > 1) {
        dealTagModalCtls.forEach((dealTagModalCtl) => {
            const clones = [...dealTagModalCtls].filter(ctl =>
                ctl !== dealTagModalCtl &&
                ctl.dataset.target === dealTagModalCtl.dataset.target
            );
            if (clones.length) {
                clones.forEach((clone, index) => {
                    clone.dataset.target += index;
                    clone.closest('.value-message__container')
                        .querySelector('.modal')
                        .id += index;
                });
            }
        });
    }
}
$(document).ready(function() {
    $(document).on('click', '.promoCopy, .promoCopySimo', function() {
        let copyText = $(this).attr('data-attr-copy');
        let clipBoardElem = document.createElement('textarea');
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = copyText;
        clipBoardElem.select();
        navigator.clipboard.writeText(clipBoardElem.value);
        document.execCommand('copy');
        document.body.removeChild(clipBoardElem);
    });
    $(document).on('hide.bs.modal', '.promoModal', function() {
        const focusedElement = document.activeElement;
        // Check if the focused element is inside this modal
        if (this.contains(focusedElement)) {
            focusedElement.blur();
        }
    });
    $(document).on('click', '.promoCopy, .promoCopySimo', function() {
        const copyText = $(this).attr('data-attr-copy');
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(copyText).catch(() => {
                fallbackCopy(copyText);
            });
        } else {
            fallbackCopy(copyText);
        }
        // Prevent Safari accessibility warning
        this.blur();
    });
    function fallbackCopy(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }
});
